import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';

export function ProfileItem({
  item,
  onChange,
  index,
  placeholder = '',
}: ItemProps<string> & { placeholder?: string }) {
  return (
    <InputGroup size="small">
      <InputGroup.Addon>Profile</InputGroup.Addon>
      <InputGroup.Input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={item}
        onChange={(e) => onChange(e.target.value)}
        data-cy={`allowed-profile-${index}-input`}
      />
    </InputGroup>
  );
}
